import { render, staticRenderFns } from "./multiple-brand-profile.vue?vue&type=template&id=401ed4e2&scoped=true"
import script from "./multiple-brand-profile.vue?vue&type=script&lang=js"
export * from "./multiple-brand-profile.vue?vue&type=script&lang=js"
import style0 from "./multiple-brand-profile.vue?vue&type=style&index=0&id=401ed4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401ed4e2",
  null
  
)

export default component.exports